<app-header></app-header>
<div class="container m-auto" id="overarching-container">
  <div class="row">
    <div class="col">
      <div [@routeAnimations]="o && o.activatedRouteData && o.activatedRouteData['animation']">
        <router-outlet #o="outlet"></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-message-display></app-message-display>